<template>
  <div>
    <div class="logo-wrapper" style="padding: 20px; text-align: center;">
      <Logo />
    </div>
    <div class="logo-icon-wrapper">
      <router-link to="/">
        <img
          class="img-fluid"
          src="../../../../assets/images/logo/logo-icon.png"
          alt=""
      /></router-link>
    </div>
    <Nav />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import Logo from './logo.vue';
  import Nav from './nav.vue';

  export default {
    name: 'Sidebar',
    components: {
      Logo,
      Nav,
    },
    computed: {
      ...mapState({
        menuItems: (state) => state.old_menu.data,
        activeoverlay: (state) => state.old_menu.activeoverlay,
      }),
    },
    methods: {
      toggle_sidebar() {
        this.$store.dispatch('old_menu/opensidebar');
        this.$store.state.old_menu.activeoverlay = false;
      },
    },
  };
</script>
